import { render } from "./AtsiriEatMenus.vue?vue&type=template&id=d54b0ae0&scoped=true&ts=true"
import script from "./AtsiriEatMenus.vue?vue&type=script&lang=ts"
export * from "./AtsiriEatMenus.vue?vue&type=script&lang=ts"

import "./AtsiriEatMenus.vue?vue&type=style&index=0&id=d54b0ae0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54b0ae0"]])

export default __exports__